export const normalizePath = (path: string): string => {
    return path?.replace(/\/:[^/]+/g, '');
  };

/**
 * Paths that must never be used as a redirect target — '/', '/check' and '/today'
 * all resolve to a landing page themselves, so sending a login's `?redirect=` back
 * to one risks bouncing the user around instead of landing them.
 * Keep every redirect-only route in here (asserted by pathUtils.test.ts).
 */
export const NON_LANDING_PATHS = [
  '/',
  '/check',
  '/today',
  '/mimic',
  '/sso/callback',
  '/user/login',
  '/user/register',
  '/user/reset-password',
  '/user/set-password',
];

/** Strips query, hash and trailing slash so '/today?x=1' and '/today/' still match. */
const stripPath = (path: string): string => {
  const bare = path?.split(/[?#]/)[0] || '';
  return bare.length > 1 ? bare.replace(/\/+$/, '') : bare;
};

export const isLandingPath = (path?: string): boolean => {
  // '//host' is protocol-relative and browsers normalise '/\' to it, so both would
  // leave the app — this guard also runs on the ?redirect query param.
  if (!path || !path.startsWith('/') || /^\/[/\\]/.test(path)) return false;
  return !NON_LANDING_PATHS.includes(stripPath(path));
};
